import { notificationManager } from "@/services/notification-manager";
import router from "@/router";
import { store } from "@/main";
import { getTranslation } from "@/services/translation-manager";
import { loginManager } from "@/services/login-manager";
import { useMainStore } from "@/store";

class TimeoutManager {
  timer = null;
  interval = null;
  timerLength = 60 * 1000;
  intervalLength = 60 * 1000 * 5;

  // intervalLength = 3 * 1000;

  watchActivity() {
    if (
      store.isIdle &&
      !store.error &&
      router.currentRoute.value.name !== "Home" &&
      router.currentRoute.value.name !== "JPO" &&
      router.currentRoute.value.name !== "Login"
    ) {
      this.setTimer();
      notificationManager
        .showAlert(
          getTranslation(507),
          getTranslation(508),
          true,
          true,
          getTranslation(509),
          getTranslation(1),
          this.timerLength,
        )
        .then((res) => {
          if (res.isDenied) {
            this.redirect();
          } else if (res.isDismissed && res.dismiss === "timer") {
            store.setIdleScreen(true);
          }
          this.stopTimer();
        });
    } else if (store.isIdle && router.currentRoute.value.name === "Home") {
      store.setInitialized(true);
      store.setIdleScreen(true);
    } else {
      store.setInitialized(false);
    }
  }

  setTimer() {
    this.timer = setTimeout(this.timerCallback, this.timerLength);
  }

  stopTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  timerCallback = () => {
    store.setInitialized(true);
    this.redirect();
  };

  redirect() {
    router.push({ name: "Home" });
  }

  watchUpdate() {
    if (!this.interval && router.currentRoute.value.name !== "Login") {
      this.setInterval();
    }
  }

  stopInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  setInterval() {
    this.interval = setInterval(this.updateCallback, this.intervalLength);
  }

  updateCallback = () => {
    if (!useMainStore().background) {
      loginManager.ping().then((res) => {
        if (res) {
          useMainStore().setJpoUrl(res.jpo_url);
          localStorage.setItem("aixam-jpo-url", res.jpo_url);
        }
        if (res === "stop") {
          this.stopInterval();
          this.stopTimer();
        } else if (res && res.action_id) {
          loginManager.updateAction(res.action_id).then((res) => {
            if (res && res.success) {
              notificationManager.showAlert(
                getTranslation(510),
                getTranslation(511),
                false,
                false,
                null,
                null,
                5000,
                false,
              );
              setTimeout(() => {
                location.href = "/";
              }, 5000);
            }
          });
        }
      });
    }
  };
}

export const timeoutManager = new TimeoutManager();
